import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=b11a4e3e&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=js"
export * from "./Follow.vue?vue&type=script&lang=js"
import style0 from "./Follow.vue?vue&type=style&index=0&id=b11a4e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11a4e3e",
  null
  
)

export default component.exports